<template lang="pug">
v-container
  v-dialog(v-model="show_create", max-width="600")
    Appointment
  //- Header
  v-row(align="center", justify="space-between")
    v-col(cols="12", sm="3")
      h2.secondary--text(v-if="user.role.slug == 'vet'") Citas Médicas
      h2.secondary--text(v-if="user.role.slug == 'owner'") Mis Citas Médicas
    v-col(cols="12", sm="3")
      v-btn(outlined, color="secondary", @click="createAppointment") Añadir Cita Médica
  Table(
    :loading="loading",
    :headers="headers",
    @edit="editAppointment",
    @delete="eraseAppointment",
    :items="appointments.results",
    @getPage="getAppointmentPage",
    :pageCount="appointments.links.last_page",
    :itemsPerPage="appointments.links.per_page"
  )
</template>

<script>
import { mapState } from "vuex";
import Table from "@/components/Table.vue";
import appointmentAPI from "@/api/appointment";
import Appointment from "@/components/Appointment.vue";

export default {
  name: "appointments",
  components: {
    Table,
    Appointment
  },
  async created() {
    if (!this.auth_token) this.$router.push("/auth/login");

    this.getAppointmentPage(1);
    this.$store.dispatch("pets/getPetsWithoutPag", this.auth_token);
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      auth_token: state => state.auth.auth_token,
      appointments: state => state.appointments.appointments
    })
  },
  data() {
    return {
      loading: false,
      show_create: false,
      headers: [
        { text: "Mascota", value: "pet.name" },
        { text: "Razones", value: "reason" },
        { text: "Veterinario", value: "vet.last_name" },
        { text: "Propietario", value: "owner.username" },
        { text: "Fecha", value: "date" },
        { text: "Acciones", value: "actions" }
      ]
    };
  },
  methods: {
    createAppointment() {
      this.show_create = true;
    },
    async getAppointmentPage(page) {
      await this.$store.dispatch("appointments/getAppointments", {
        token: this.auth_token,
        page: page
      });
    },
    editAppointment(appointment) {
      this.$router.push(`/appointments/${appointment.id}`);
    },
    async eraseAppointment(appointment) {
      this.$swal({
        title: `¿Estas seguro de borrar la cita médica de ${appointment.pet.name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No"
      }).then(async result => {
        if (result.value) {
          const response = await appointmentAPI.deleteAppointment(
            appointment.id,
            this.auth_token
          );

          if (response.status) {
            this.$swal({
              title: `Cita Médica Borrada`,
              icon: "success"
            });
            await this.$store.dispatch("appointments/getAppointments", {
              token: this.auth_token,
              page: 1
            });
          } else {
            this.$swal({
              title: response.data,
              icon: "error"
            });
          }
        }
      });
    }
  }
};
</script>
